import { http } from "@/shared/api/axios";
import type {
  AttendanceRecord,
  RecordAttendanceRequest,
  UpdateAttendanceRequest,
  AttendanceParams,
} from "../model/types";

export const checkIn = async (shiftId: number): Promise<AttendanceRecord> => {
  const response = await http.post<AttendanceRecord>(
    `/v1/scheduler/attendance/${shiftId}/check-in`
  );
  return response.data;
};

export const checkOut = async (shiftId: number): Promise<AttendanceRecord> => {
  const response = await http.post<AttendanceRecord>(
    `/v1/scheduler/attendance/${shiftId}/check-out`
  );
  return response.data;
};

export const recordAttendance = async (
  data: RecordAttendanceRequest
): Promise<AttendanceRecord> => {
  const response = await http.post<AttendanceRecord>(
    "/v1/scheduler/attendance",
    data,
    { _skipErrorToast: true } as never
  );
  return response.data;
};

export const updateAttendance = async (
  id: number,
  data: UpdateAttendanceRequest
): Promise<AttendanceRecord> => {
  const response = await http.put<AttendanceRecord>(
    `/v1/scheduler/attendance/${id}`,
    data,
    { _skipErrorToast: true } as never
  );
  return response.data;
};

export const fetchAttendanceByShift = async (
  shiftId: number
): Promise<AttendanceRecord[]> => {
  const response = await http.get<AttendanceRecord[]>(
    `/v1/scheduler/attendance/by-shift/${shiftId}`
  );
  return response.data;
};

export const fetchAttendance = async (
  params: AttendanceParams
): Promise<AttendanceRecord[]> => {
  const response = await http.get<AttendanceRecord[]>(
    "/v1/scheduler/attendance",
    { params }
  );
  return response.data;
};
